<script>
import _debounce from "lodash/debounce";
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";

export default {
  name: 'SearchDataDischargerModal',
  components: {
    CommonTableComponent
  },
  mixins: [pagination, tableSearch],
  props: ['dataSearch', 'errorValid'],
  data() {
    return {
      currentInputSelectData: "",
      header: this.$constant.tableHeaders.common.searchs.dischargers,
      busyGetData: false,
      data: [],
      visible: false,
      filters: {
        searchValue: "",
        column: "dischargers.discharger_cd",
        dir: "ASC",
        page: 1
      }
    };
  },
  methods: {
    async getData() {
      this.busyGetData = true;
      const response = await this.$http.get(apiEndpoints.popup_search_dischargers, {
        ...this.filters,
      });
      const { status, data } = response;
      this.busyGetData = false;
      if (status) {
        const result = data.result;
        this.data = this.$_.isEmpty(result) ? [] : result;
        // const meta = this.$_.isEmpty(result.meta) ? [] : result.meta;
        // this.setMeta(meta);
      }
    },
    updateValue: function(value) {
      this.dataSearch.discharger = value;
      this.$emit('dataSelected', this.dataSearch)
      this.closeModal();
    },
    openModal() {
      this.$bvModal.show("modal-select-data-business_person");
    },
    closeModal() {
      this.$bvModal.hide("modal-select-data-business_person");
    },
    performDebounceSearch () {
      this.resetToFirstPage();
      this.updateUrlFilters();
    },
    updateUrlFilters () {
      this.getData()
    },
    isInputError(input){
      if (!this.errorValid) return false;

      return !!this.errorValid[input];
    },
  },
  watch: {
    "filters.page": {
      immediate: false,
      handler() {
        this.updateUrlFilters();
      }
    },
  },
  computed: {
    headers() {
      return this.header;
    },
    inputSearch: {
      get() {
        return this.dataSearch.discharger;
      },
      set(newValue) {
        this.dataSearch.discharger = newValue;
      }
    },
  }
};
</script>
<template>
  <div class="mb-2 d-xl-flex">
    <slot name="label">
      <label :for="'business_person'" class="col-form-label text-nowrap me-2"
      >事業者略称</label
      >
    </slot>
    <div class="d-flex w-100">
      <div class="w-100 me-2">
        <input
          type="text"
          class="form-control me-2"
          id="business_person"
          v-model="inputSearch"
          :class="{
              'is-invalid': isInputError('discharger')
            }"
        />
        <div
          v-if="isInputError('discharger')"
          class="invalid-feedback"
        >
          {{ errorValid['discharger'][0] }}
        </div>
      </div>
      <b-button
        @click="openModal()"
        variant="outline-info"
        class="cus-h-btn"
      >
        <i class="bx bx-file-find"></i>
      </b-button>
    </div>
    <!-- modal area -->
    <b-modal
      title="事業者略称一覧"
      size="xl"
      id="modal-select-data-business_person"
      centered
      title-class="font-18"
      hide-footer
      scrollable
      @show="getData"
    >
      <b-row>
        <div>
          <b-form-input
            placeholder="フィルター..."
            v-model="filters.searchValue"
            v-on:keyup.enter="performDebounceSearch"
            type="text"
            id="name"
          ></b-form-input>
        </div>
      </b-row>
      <b-row class="mt-2">
        <b-overlay
          :show="busyGetData"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <CommonTableComponent :height-class="`table-wrapper-500`">
            <thead class="table-light">
              <tr>
                <th
                  v-for="(item, index) in headers"
                  :key="index"
                  :class="getHeaderClass(item)"
                >
                  <span v-if="item.sortable" @click="clickSort(item.value)">
                    {{ item.text }}
                    <i :class="getSortClass(item.value)"></i>
                  </span>
                  <span v-else>
                    {{ item.text }}
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in data"
                :key="index"
                class="cursor-pointer"
                @click="updateValue(item.name_abbreviated)"
              >
                <td>
                  {{ item.discharger_cd }}
                </td>
                <td>
                  {{ item.name_abbreviated }}
                </td>
                <td>
                  {{ item.address }}
                </td>
                <td>
                  {{ item.tel }}
                </td>
                <td>
                  {{ item.discharger_person_in_charge }}
                </td>
                <td>
                  {{ item.zz_own }}
                </td>
              </tr>
              <tr v-if="!data.length && !busyGetData">
                <td :colspan="headers.length" class="text-center">
                  データなし。
                </td>
              </tr>
            </tbody>
          </CommonTableComponent>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>
<style scoped>
.cus-h-btn {
  max-height: 38px;
}
</style>
